<template>
  <span class="text-foreground-subtle">—</span>
</template>
